import React, { Fragment } from "react";
import PropTypes from "prop-types";
import { LoadingIndicator } from "../../../../../components/simple";

import "./styles.scss";

function LocationList(props) {
  const { list, isLoading, country } = props;

  return (
    <Fragment>
      <div className="preset-variable-list">
        <div className="group-container">
          <div className="group">
            {isLoading ? (
              <div
                style={{
                  height: "100%",
                  width: "100%",
                  paddingTop: 10,
                  paddingBottom: 10,
                  paddingRight: 50,
                  paddingLeft: 50
                }}
              >
                <LoadingIndicator />
              </div>
            ) : (
              <>
                {list.map((variable, varIndex) => (
                  <Fragment key={`preset-variable-list-render-${variable.id}`}>
                    {list.length === 1 ? (
                      <span className="variable-item">
                        {variable.name} {country ? "- Country" : ""}
                      </span>
                    ) : (
                      <span className="variable-item">{variable.name}</span>
                    )}
                    {varIndex !== list.length - 1 && (
                      <span className="operand">AND</span>
                    )}
                  </Fragment>
                ))}
              </>
            )}
          </div>
        </div>
      </div>
    </Fragment>
  );
}

LocationList.propTypes = {
  list: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string
    })
  ).isRequired,
  country: PropTypes.bool.isRequired,
  isLoading: PropTypes.bool.isRequired
};

export default LocationList;
